var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

import { assign, upperFirst } from 'lodash';
import { DynamicComponent } from './component'; // 组件唯一标识计数

var idCounter = 0;
/**
 * 组件类工厂方法
 *
 * 根据组件描述信息创建对应的组件类
 *
 * 动态组件会分配唯一标识，用于维护组件生命周期中的状态，组件 props 会添加 componentId
 *
 * @param name - 组件名称
 * @param desc - 组件描述信息
 */

export function ComponentFactory(name, desc) {
  var basisProps = assign({}, desc);
  delete basisProps.component;
  delete basisProps.entity;
  delete basisProps.entities;

  var NewDynamicComponent = function (_super) {
    __extends(NewDynamicComponent, _super);

    function NewDynamicComponent(props) {
      var _this = _super.call(this, props) || this;

      _this.metadata = desc;
      _this.basisProps = basisProps;
      _this.componentId = desc.component + "-" + idCounter;
      idCounter++;
      return _this;
    }

    return NewDynamicComponent;
  }(DynamicComponent); // @ts-ignore


  NewDynamicComponent.displayName = '$' + upperFirst(name);
  return NewDynamicComponent;
}